import { ApiParameter, del, get, HasPagingParameters, patch, post } from "@insite/client-framework/Services/ApiService";
import { CustomerPartNumber, CustomerPartNumberCollectionModel } from "@thos/Services/ThosApiModels";

export interface GetCustomerPartNumbersApiParameter extends ApiParameter, HasPagingParameters {
    partNumber?: string;
    customerPartNumber?: string;
    sort?: string;
}

export interface CreateCustomerPartNumbersParameter extends ApiParameter {
    partId: string;
    customerPartNumbers: string[];
}

export interface UpdateCustomerPartNumbersParameter extends ApiParameter {
    id: string;
    customerPartNumbers: string[];
}

const customerPartNumbersUrl = "api/v1/customerpartnumbers";

export function getCustomerPartNumbers(
    parameter: GetCustomerPartNumbersApiParameter,
): Promise<CustomerPartNumberCollectionModel> {
    return get<CustomerPartNumberCollectionModel>(`${customerPartNumbersUrl}`, parameter);
}

export function createCustomerPartNumber(parameter: CreateCustomerPartNumbersParameter): Promise<CustomerPartNumber> {
    return post<CreateCustomerPartNumbersParameter, CustomerPartNumber>(`${customerPartNumbersUrl}`, parameter);
}

export function updateCustomerPartNumber(parameter: CustomerPartNumber): Promise<CustomerPartNumber> {
    return patch<CustomerPartNumber>(`${customerPartNumbersUrl}/${parameter.id}`, parameter);
}

export function deleteCustomerPartNumber(parameter: CustomerPartNumber) {
    return del(`${customerPartNumbersUrl}/${parameter.id}`);
}
